import React, { useState } from 'react';
import { Container, Row, Col, Card, Accordion } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle, faPrint, faMobileAlt, faShippingFast, faExchangeAlt, faMoneyBillWave } from '@fortawesome/free-solid-svg-icons';
import './FAQ.css';

const FAQ = () => {
  const [activeKey, setActiveKey] = useState('0');

  const faqCategories = [
    {
      id: 'general',
      title: 'Genel Sorular',
      icon: faQuestionCircle,
      color: '#8B4513',
      questions: [
        {
          question: 'Mr. Brown kılıfları neden özel?',
          answer: 'Mr. Brown kılıfları, yüksek kaliteli sublimasyon baskı teknolojisi kullanılarak özenle üretilmektedir. Bu teknoloji sayesinde, renkler canlılığını uzun süre korur ve görüntüler net bir şekilde kılıf yüzeyine aktarılır. Üstün kaliteli malzemeler ve özel koruma özellikleriyle telefonunuzu şık bir şekilde korur.'
        },
        {
          question: 'Ürünlerin garantisi var mı?',
          answer: 'Evet, tüm Mr. Brown kılıfları için 1 yıl üretim hatalarına karşı garanti sunuyoruz. Baskıların solması, kılıfın çatlaması veya üretim kaynaklı herhangi bir sorun durumunda ürünü değiştiriyoruz.'
        },
        {
          question: 'Siparişimi ne zaman teslim alabilirim?',
          answer: 'Standart tasarımları genellikle 1-3 iş günü içinde kargoya veriyoruz. Özel tasarım siparişleri için bu süre 2-4 iş günüdür. Kargo süreci ise lokasyonunuza bağlı olarak 1-3 iş günü sürebilir. Sipariş durumunuzu "Sipariş Ara" veya "Siparişlerim" sayfasından kontrol edebilirsiniz.'
        }
      ]
    },
    {
      id: 'sublimation',
      title: 'Sublimasyon Baskı Hakkında',
      icon: faPrint,
      color: '#A0522D',
      questions: [
        {
          question: 'Sublimasyon baskı nedir?',
          answer: 'Sublimasyon baskı, özel mürekkeplerin ısı ve basınç uygulanarak katı halden doğrudan gaz haline geçirilmesi ve bu şekilde görüntünün malzeme ile bütünleşmesini sağlayan ileri bir baskı teknolojisidir. Bu sayede baskılar pürüzsüz, yüksek çözünürlüklü ve solmaya karşı dayanıklı olur.'
        },
        {
          question: 'Sublimasyon baskılı kılıfların avantajları nelerdir?',
          answer: 'Sublimasyon baskı teknolojisinin avantajları:\n• Yüksek çözünürlüklü, canlı renkler\n• Solmaya ve çizilmeye karşı yüksek dayanıklılık\n• Pürüzsüz yüzey hissi (kabartma yok)\n• Kalıcı baskı (soyulmaz, çıkmaz)\n• Detaylı ve karmaşık tasarımları net bir şekilde basabilme'
        },
        {
          question: 'Baskılar ne kadar dayanıklıdır?',
          answer: 'Sublimasyon baskılar, doğru kullanım ile yıllarca solmadan ve bozulmadan kalabilir. Baskı, mürekkebin malzemeye nüfuz etmesiyle oluştuğu için çıkma, soyulma veya aşınma yaşanmaz. Normal kullanımda uzun yıllar ilk günkü canlılığını korur.'
        },
        {
          question: 'Özel tasarımların baskı kalitesi nasıl?',
          answer: 'Özel tasarımlarınız, standart koleksiyonumuzdaki ürünlerle aynı yüksek kalite standartlarında basılır. Tasarımınızın baskı kalitesi, yüklediğiniz görselin çözünürlüğüne bağlıdır. En iyi sonuç için en az 300 DPI çözünürlükte ve yüksek kaliteli görseller kullanmanızı öneriyoruz.'
        }
      ]
    },
    {
      id: 'products',
      title: 'Ürünler Hakkında',
      icon: faMobileAlt,
      color: '#CD853F',
      questions: [
        {
          question: 'Hangi telefon modelleri için kılıf üretiyorsunuz?',
          answer: 'Güncel olarak iPhone\'un popüler ve yaygın kullanılan modelleri için kılıf üretiyoruz. Desteklenen tüm modelleri "Kendin Tasarla" sayfasından inceleyebilirsiniz. Listede olmayan bir iPhone modeli için kılıf ihtiyacınız varsa, lütfen bizimle iletişime geçin.'
        },
        {
          question: 'Kılıfların koruma düzeyi nedir?',
          answer: 'Kılıflarımız, günlük kullanımda telefonunuzu düşmelere, çizilmelere ve darbelere karşı korumak için tasarlanmıştır. Tüm köşelerde ekstra koruma bulunur ve hafif düşmelerde telefonunuzu güvende tutar. Kılıf yüzeyine, dayanıklı temperli cam üzerine yüksek kaliteli baskı uygulanır. Ancak, ekstrem koşullarda veya yüksek darbelerde tam koruma garanti edilemez.'
        },
        {
          question: 'Kılıfların malzemesi nedir?',
          answer: 'Kılıflarımız, TPU (Termoplastik Poliüretan), sert plastik ve temperli cam malzemelerden üretilmiştir. TPU malzeme esnekliği ve dayanıklılığı bir arada sunarak telefonunuzu sararken darbelere karşı etkili koruma sağlar. Arka yüzeyde kullanılan sert plastik yapı, dayanıklılığı artırırken temperli cam kaplama ise şık bir görünüm ve çizilmelere karşı ekstra direnç kazandırır. Ayrıca, tüm malzemeler uzun ömürlü olup, sararma ve yıpranmaya karşı dirençlidir.'
        },
        {
          question: 'Kablosuz şarj ile kullanılabilir mi?',
          answer: 'Evet, tüm kılıflarımız kablosuz şarj ile uyumludur. İnce yapısı sayesinde şarj sinyallerini engellemez ve telefonunuzu çıkarmadan kablosuz şarj edebilirsiniz.'
        }
      ]
    },
    {
      id: 'orders',
      title: 'Sipariş ve Teslimat',
      icon: faShippingFast,
      color: '#8B4513',
      questions: [
        {
          question: 'Siparişim ne kadar sürede hazırlanır?',
          answer: 'Standart tasarımlı ürünler genellikle 1-3 iş günü içinde hazırlanıp kargoya verilir. Özel tasarım ürünlerde ise bu süre 2-4 iş günüdür. Yoğun dönemlerde bu süre biraz uzayabilir.'
        },
        {
          question: 'Kargo takibini nasıl yapabilirim?',
          answer: 'Siparişiniz kargoya verildiğinde, kayıtlı telefon numaranıza kargo takip numarası ve bağlantısı gönderilir. Ayrıca "Sipariş Ara" sayfasından telefon numaranızı girerek de siparişinizin durumunu kontrol edebilirsiniz.'
        },
        {
          question: 'Yurtdışına gönderim yapıyor musunuz?',
          answer: 'Şu anda yalnızca yurt içi gönderim yapıyoruz. Türkiye\'nin her noktasına kargo hizmeti sunmaktayız. Kargo ücreti ve teslimat süresi, bulunduğunuz ile göre değişiklik gösterebilir. Satın alma işlemi sırasında adres bilgilerinize göre bu detaylar otomatik olarak güncellenir.'
        },
        {
          question: 'Toplu sipariş verebilir miyim?',
          answer: 'Evet, kurumsal hediyeler veya etkinlikler için toplu sipariş verebilirsiniz. 10 adetten fazla sipariş için özel indirimler sunuyoruz. Toplu siparişleriniz için lütfen bizimle iletişime geçin.'
        }
      ]
    },
    {
      id: 'returns',
      title: 'İade ve Değişim',
      icon: faExchangeAlt,
      color: '#A0522D',
      questions: [
        {
          question: 'İade politikanız nedir?',
          answer: 'Ürünlerinizi, teslim aldığınız tarihten itibaren 14 gün içinde iade edebilirsiniz. İade etmek istediğiniz ürünlerin kullanılmamış, hasarsız, orijinal ambalajında ve ambalajı açılmamış olması gerekmektedir. Kendi Tasarladığınız ürünler iade edilemez.'
        },
        {
          question: 'Ürün değişimi nasıl yapılır?',
          answer: 'Değişim talepleriniz için "İade Talebi" oluşturarak bize ulaştırabilirsiniz. Değişim sebebinizi belirttikten sonra talebiniz 24 saat içinde incelenir ve onaylanırsa yeni ürün hazırlanıp gönderilir. Eğer değişim talebinizin nedeni satıcı kaynaklı bir hata ise, kargo ücreti tarafımızdan karşılanır. Diğer durumlarda kargo ücreti alıcıya aittir.'
        },
        {
          question: 'Hatalı ürün gelirse ne yapmalıyım?',
          answer: 'Ürün elinize ulaştığında herhangi bir üretim hatası veya hasar tespit ederseniz, 48 saat içinde müşteri hizmetleri ile iletişime geçin. Hatalı ürünün fotoğrafını e-posta ile göndermeniz durumunda, ürün incelendikten sonra yenisi ücretsiz olarak gönderilecektir.'
        }
      ]
    },
    {
      id: 'payment',
      title: 'Ödeme Seçenekleri',
      icon: faMoneyBillWave,
      color: '#CD853F',
      questions: [
        {
          question: 'Hangi ödeme yöntemlerini kullanabiliyorum?',
          answer: 'Kredi kartı ve banka kartı ile ödeme yapabilirsiniz. Tüm kartlı ödemeleriniz 3D Secure güvenlik protokolü ile güvence altındadır. Ayrıca kredi kartı ile yapılan alışverişlerde taksit seçenekleri sunulmaktadır.'
        },
        {
          question: 'Taksitli ödeme yapabilir miyim?',
          answer: 'Evet, anlaşmalı bankaların kredi kartları ile 3, 6 ve 9 taksit seçenekleri sunuyoruz. Farklı bankaların taksit imkanları için ödeme sayfasını ziyaret edebilirsiniz.'
        },
        {
          question: 'Kapıda ödeme seçeneği var mı?',
          answer: 'Şu anda kapıda ödeme seçeneğimiz bulunmamaktadır. Ödemelerinizi kredi kartı veya banka kartı ile güvenli bir şekilde gerçekleştirebilirsiniz.'
        },
        {
          question: 'Ödeme bilgilerim güvende mi?',
          answer: 'Kesinlikle. Tüm ödeme işlemleriniz SSL sertifikalı güvenli bağlantı üzerinden gerçekleştirilir. Kredi kartı bilgileriniz sistemimizde saklanmaz ve tüm işlemler 3D Secure güvenlik protokolü ile yapılır.'
        }
      ]
    }
  ];

  return (
    <div className="faq-page">
      <Helmet>
        <title>Sıkça Sorulan Sorular | Mr. Brown</title>
        <meta name="description" content="Mr. Brown sublimasyon baskılı telefon kılıfları hakkında sıkça sorulan sorular ve cevapları." />
      </Helmet>

      <Container className="py-5">
        <h1 className="display-5 fw-bold mb-3">Sıkça Sorulan Sorular</h1>
        <p className="lead mb-5">
          Mr. Brown sublimasyon baskılı telefon kılıfları hakkında merak ettiklerinizi burada bulabilirsiniz.
        </p>

        <Row className="mb-5">
          {faqCategories.map((category, index) => (
            <Col md={6} lg={4} className="mb-4" key={category.id}>
              <Card 
                className="faq-category-card h-100" 
                onClick={() => document.getElementById(category.id).scrollIntoView({ behavior: 'smooth' })}
              >
                <Card.Body className="d-flex flex-column align-items-center text-center p-4">
                  <div 
                    className="category-icon-container mb-3" 
                    style={{ backgroundColor: `${category.color}20` }}
                  >
                    <FontAwesomeIcon 
                      icon={category.icon} 
                      className="category-icon" 
                      style={{ color: category.color }}
                    />
                  </div>
                  <h3 className="h5 mb-3">{category.title}</h3>
                  <p className="text-muted mb-0">
                    {category.questions.length} soru
                  </p>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {faqCategories.map((category, categoryIndex) => (
          <div key={category.id} id={category.id} className="mb-5 pt-2">
            <Row className="justify-content-center mb-4">
              <Col md={10} lg={8}>
                <h2 className="h3 mb-4">
                  <FontAwesomeIcon 
                    icon={category.icon} 
                    style={{ color: category.color }}
                    className="me-3"
                  />
                  {category.title}
                </h2>

                <Accordion defaultActiveKey={categoryIndex === 0 ? "0" : null}>
                  {category.questions.map((item, i) => (
                    <Accordion.Item key={i} eventKey={i.toString()}>
                      <Accordion.Header>{item.question}</Accordion.Header>
                      <Accordion.Body>
                        {item.answer.split('\n').map((str, index) => (
                          <React.Fragment key={index}>
                            {str}
                            {index !== item.answer.split('\n').length - 1 && <br />}
                          </React.Fragment>
                        ))}
                      </Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              </Col>
            </Row>
          </div>
        ))}

        <Row className="justify-content-center">
          <Col md={10} lg={8}>
            <div className="contact-support-card text-center p-4 mt-4">
              <h3 className="h4 mb-3">Sorularınız cevap bulamadınız mı?</h3>
              <p className="mb-4">
                Merak ettiğiniz başka konular varsa, müşteri hizmetlerimiz her zaman yardıma hazır.
              </p>
              <div className="d-flex justify-content-center gap-3">
                <a href="/contact" className="support-btn">
                  İletişime Geçin
                </a>
                <a href="mailto:mr.browncases@gmail.com" className="support-btn">
                  E-posta Gönderin
                </a>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default FAQ; 